import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/api";
import { useNotifications } from "./NotificationProvider";
import "../styles/AccountSection.css";

const AccountSection = () => {
  const { showNotification } = useNotifications();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  useEffect(() => {
    apiFetch("/api/auth/me")
      .then((data) => {
        setUser(data);
      })
      .catch((err) => {
        console.error(err);
        if (!err.sessionExpired) showNotification("error", err.message);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, [showNotification]);

  const updatePasswordField = (field, value) => {
    setPasswordForm(prev => ({ ...prev, [field]: value }));
  };

  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    setIsChangingPassword(true);

    try {
      const data = await apiFetch("/api/auth/password", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(passwordForm),
      });

      setPasswordForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      showNotification("success", data.message || "Passwort wurde geändert.");
    } catch (err) {
      console.error(err);
      if (!err.sessionExpired) showNotification("error", err.message);
    } finally {
      setIsChangingPassword(false);
    }
  };

  if (loading) {
    return (
      <div className="section-content">
        <p>Lädt...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="section-content">
        <p>Fehler: {error}</p>
      </div>
    );
  }

  return (
    <div className="section-content account-section">
      <section className="account-card">
        <div className="account-card-header">
          <h2>Account</h2>
        </div>
        <dl className="account-details">
          <div>
            <dt>Name</dt>
            <dd>{user.first_name} {user.last_name}</dd>
          </div>
          <div>
            <dt>E-Mail</dt>
            <dd>{user.email}</dd>
          </div>
          <div>
            <dt>Rolle</dt>
            <dd>{user.accountType}</dd>
          </div>
        </dl>
      </section>

      <section className="account-card">
        <div className="account-card-header">
          <h2>Passwort ändern</h2>
        </div>
        <form className="password-change-form" onSubmit={handlePasswordSubmit}>
          <label>
            Aktuelles Passwort
            <input
              type="password"
              autoComplete="current-password"
              value={passwordForm.currentPassword}
              onChange={event => updatePasswordField("currentPassword", event.target.value)}
              disabled={isChangingPassword}
              required
            />
          </label>
          <label>
            Neues Passwort
            <input
              type="password"
              autoComplete="new-password"
              value={passwordForm.newPassword}
              onChange={event => updatePasswordField("newPassword", event.target.value)}
              disabled={isChangingPassword}
              minLength={6}
              required
            />
          </label>
          <label>
            Neues Passwort wiederholen
            <input
              type="password"
              autoComplete="new-password"
              value={passwordForm.confirmPassword}
              onChange={event => updatePasswordField("confirmPassword", event.target.value)}
              disabled={isChangingPassword}
              minLength={6}
              required
            />
          </label>
          <button type="submit" disabled={isChangingPassword}>
            {isChangingPassword ? "Speichert..." : "Passwort speichern"}
          </button>
        </form>
      </section>
    </div>
  );
};

export default AccountSection;
